import { Button, IconButton } from "@/components-v2/Button";
import { IconProps } from "@/components-v2/Icon";
import { Tag } from "@/components-v2/Tag";
import { TMessage } from "@/i18n/tt";
import { DCMouseEventHandler, useMouseEventHandler } from "@/stores/RootStoreContext";
import { observer } from "mobx-react";

export const ChangePermissionDialogButton = observer(
  ({
    numberOfpermissions,
    onClick,
    variant = "button",
  }: {
    numberOfpermissions: number;
    onClick: DCMouseEventHandler<HTMLButtonElement>;
    variant?: "button" | "icon-button";
  }) => {
    const clickHandler = useMouseEventHandler(onClick);
    const icon: IconProps = numberOfpermissions > 1 ? { name: "users" } : { name: "lock" };
    const tooltip: TMessage =
      numberOfpermissions > 1
        ? { key: "permissions.button.tooltip.public", params: { n: numberOfpermissions } }
        : { key: "permissions.button.tooltip.private" };
    return variant === "icon-button" ? (
      <IconButton
        icon={icon}
        tooltip={tooltip}
        onClick={clickHandler}
        tag={`${numberOfpermissions}`}
        tagColor={numberOfpermissions > 1 ? "success" : "neutral"}
      />
    ) : (
      <Button
        variant={"basic"}
        icon={icon}
        tooltip={tooltip}
        label={
          <Tag
            color={numberOfpermissions > 1 ? "success" : "neutral"}
            label={numberOfpermissions.toString()}
            isButton
          />
        }
        size={"sm"}
        onClick={clickHandler}
      />
    );
  },
);
